import React from "react";

export default function FloatingWhatsAppButton({ config }) {
  if (!config?.enabled) return null;

  const phone = config?.config?.phone;
  const message = config?.config?.message || "Hello";
  const position = config?.style?.position || "right";

  if (!phone) return null;

  const cleanPhone = phone.replace(/\D/g, "");
  const encodedMessage = encodeURIComponent(message);
  const url = `https://wa.me/${cleanPhone}?text=${encodedMessage}`;

  const positionClass =
    position === "left"
      ? "left-5"
      : "right-5";

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-5 ${positionClass} z-[9999]`}
    >
      <div className="w-14 h-14 rounded-full bg-[#25D366] shadow-xl flex items-center justify-center hover:scale-110 transition-transform">
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
          <path d="M16 .396C7.164.396 0 7.56 0 16.396c0 2.89.756 5.712 2.194 8.2L0 32l7.61-2.152a15.9 15.9 0 0 0 8.39 2.332c8.836 0 16-7.164 16-16S24.836.396 16 .396zm0 29.278c-2.548 0-5.04-.682-7.21-1.973l-.516-.305-4.518 1.278 1.206-4.402-.336-.537a13.57 13.57 0 0 1-2.09-7.34c0-7.48 6.086-13.566 13.566-13.566 3.626 0 7.036 1.413 9.602 3.98a13.49 13.49 0 0 1 3.964 9.586c0 7.48-6.086 13.566-13.566 13.566zm7.64-10.182c-.418-.209-2.474-1.22-2.857-1.36-.383-.14-.663-.21-.942.21-.279.418-1.081 1.36-1.326 1.64-.244.279-.488.314-.907.105-.418-.209-1.764-.65-3.36-2.074-1.242-1.108-2.08-2.476-2.324-2.895-.244-.418-.026-.643.183-.851.188-.187.418-.488.628-.732.209-.244.279-.418.418-.697.14-.279.07-.523-.035-.732-.105-.209-.942-2.27-1.29-3.11-.34-.82-.685-.707-.942-.72l-.802-.014c-.279 0-.732.105-1.115.523-.383.418-1.46 1.425-1.46 3.474 0 2.05 1.495 4.028 1.704 4.307.209.279 2.945 4.498 7.138 6.307 4.193 1.808 4.193 1.205 4.95 1.13.756-.07 2.474-1.01 2.823-1.987.348-.977.348-1.814.244-1.987-.104-.174-.383-.279-.802-.488z"/>
        </svg>
      </div>
    </a>
  );
}